import { v4 } from 'uuid';
import { create } from 'zustand';
import { persist } from '../../node_modules/zustand/esm/middleware.js';

const TOAST_DURATION = 5e3;
const WARNING_DURATION = 2e4;
const useAlertStore = create()(persist((set, get) => ({
  alerts: [],
  banner: void 0,
  lastDismissedBanner: void 0,
  addAlert: (alertOptions) => {
    if (alertOptions.type === "banner") {
      if (alertOptions.id === get().lastDismissedBanner) return void 0;
      const banner2 = {
        ...alertOptions,
        id: alertOptions.id ?? v4()
      };
      set({
        banner: banner2
      });
      return banner2;
    }
    const existingAlert = get().alerts.find((alert2) => alert2.id === alertOptions.id);
    if (existingAlert && alertOptions.replace !== true) return existingAlert;
    const alert = {
      ...alertOptions,
      id: alertOptions.id ?? v4()
    };
    const alerts = existingAlert ? get().alerts.filter((a) => a.id !== alert.id) : get().alerts;
    set({
      alerts: alert.type === "toast" ? [
        ...alerts,
        alert
      ] : [
        alert,
        ...alerts
      ]
    });
    return alert;
  },
  removeAlert: (id) => set({
    alerts: get().alerts.filter((alert) => alert.id !== id)
  }),
  clearAlerts: () => set({
    alerts: []
  }),
  dismissBanner: () => {
    const { banner: banner2 } = get();
    if (!banner2) return;
    set({
      banner: void 0,
      lastDismissedBanner: banner2.id
    });
  }
}), {
  name: "alerts",
  partialize: (state) => ({
    lastDismissedBanner: state.lastDismissedBanner
  })
}));
const toast = (toastOptions) => useAlertStore.getState().addAlert({
  ...toastOptions,
  type: "toast"
});
const warning = (warningOptions) => useAlertStore.getState().addAlert({
  ...warningOptions,
  type: "warning",
  timeout: warningOptions.timeout ?? WARNING_DURATION
});
const banner = (bannerOptions) => useAlertStore.getState().addAlert({
  ...bannerOptions,
  type: "banner"
});
const confirm = async (confirmOptions) => new Promise((resolve) => {
  const id = useAlertStore.getState().addAlert({
    ...confirmOptions,
    type: "confirm",
    onConfirm: () => {
      if (!id) {
        resolve(false);
        return;
      }
      useAlertStore.getState().removeAlert(id);
      resolve(true);
    },
    onCancel: () => {
      if (!id) {
        resolve(false);
        return;
      }
      useAlertStore.getState().removeAlert(id);
      resolve(false);
    }
  })?.id;
});
const prompt = async (promptOptions) => new Promise((resolve) => {
  const id = v4();
  const prompt2 = {
    ...promptOptions,
    type: "prompt",
    id,
    onConfirm: (value) => {
      if (!id) {
        resolve(false);
        return;
      }
      useAlertStore.getState().removeAlert(id);
      resolve(value);
    },
    onCancel: () => {
      if (!id) {
        resolve(false);
        return;
      }
      useAlertStore.getState().removeAlert(id);
      resolve(false);
    }
  };
  useAlertStore.getState().addAlert(prompt2);
});
const upgradePrompt = (upgradePromptOptions) => useAlertStore.getState().addAlert({
  ...upgradePromptOptions,
  type: "upgrade_prompt"
});
const removeAlert = (id) => useAlertStore.getState().removeAlert(id);

export { TOAST_DURATION, banner, confirm, useAlertStore as default, prompt, removeAlert, toast, upgradePrompt, warning };
//# sourceMappingURL=alerts.js.map
